import {Token} from "../contexts/MarketsContext/provider.interface";

export const getTokenByAddress = (tokenAddress: string = '', tokens: Token[]): Token | undefined => {
  return tokens.find((el) => el.contractAddress === tokenAddress);
};